import { Box, Icon, SystemProps } from "@storyofams/react-ui";
import { Checkmark } from "../Icons";

interface CustomCheckboxProps extends SystemProps {
  checked?: boolean;
  disabled?: boolean;
}

export const CustomCheckbox = ({
  checked,
  disabled = false,
  ...props
}: CustomCheckboxProps) => {
  return (
    <Box
      display={"flex"}
      backgroundColor={disabled ? "#1D1D1B1A" : "white"}
      cursor={disabled ? "not-allowed" : "pointer"}
      alignItems={"center"}
      justifyContent={"center"}
      {...props}
    >
      {checked && <Icon icon={Checkmark}></Icon>}
    </Box>
  );
};
